import PaymentsService from "@/services/payments";
import serviceHandler from "@/helpers/handlers/service";
export const freeTrialDaysMixin = {
  data() {
    return {
      trialDuration: "--"
    };
  },
  computed: {
    isFreeTrial() {
      return this.$route.query.is_free_trial !== "false";
    }
  },
  async created() {
    if (this.isFreeTrial && this.$route.query.campaign) {
      try {
        const {
          data: { free_trial_duration }
        } = await PaymentsService.getCampaigns(this.$route.query.campaign);

        this.trialDuration = free_trial_duration;
      } catch (e) {
        this.trialDuration = 14;
      }
    } else {
      this.trialDuration = 14;
    }
  }
};
